import React from 'react';

//Similar to Fragments
const NoDOM = props => props.children;

export default NoDOM;